import { ref, readonly } from 'vue'

export const useMonths = (initial, master) => {
  const state = ref(structuredClone(initial))

  const set = (value) => {
    state.value = value.sort((a, b) => a - b)
  }

  const reset = () => {
    state.value = structuredClone(initial)
  }

  const clear = () => {
    state.value = []
  }

  const getText = () => {
    let monthText = []
    for(let index in state.value) {
      monthText[index] = state.value[index] + '月'
    }
    return monthText.join(',')
  }

  return { months: readonly(state), master: readonly(master), set, reset, clear, getText }
}